import { gql } from "@apollo/client";

import { WISHLIST_UPDATE_FRAGMENT } from "@shared/graphql.fragments";
import { createRequestContext, getClient } from "lib/apolloClient";
import { dispatch } from "@shared/utils.events";
import { setUser } from "lib/user";

import { withGlobalSpinner } from "./api";

const ADD_USER_WISHLIST_ITEM_BY_SKU = gql`
  mutation addWishlistItemBySKU($sku: String!) {
    addWishlistItemBySKU(sku: $sku) {
      ...WishListUpdateFragment
    }
  }
  ${WISHLIST_UPDATE_FRAGMENT}
`;

const addWishlistItemBySKUInner = async (
  sku: string,
  context: Record<string, unknown>
) => {
  const result = await getClient().mutate({
    mutation: ADD_USER_WISHLIST_ITEM_BY_SKU,
    variables: {
      sku
    },
    context: createRequestContext({ sessionStrategy: "REDIRECT_TO_LOGIN" })
  });

  if (result?.data?.addWishlistItemBySKU) {
    const { wishes: wishlist } = result.data.addWishlistItemBySKU;
    setUser({
      wishlist
    });
    const newWish = wishlist.find((item) => item.variant?.sku === sku);
    if (newWish) {
      dispatch("addToWishlist", {
        item: newWish,
        context
      });
    }
  }

  if (!result.data) throw new Error("No response received");

  return result.data.addWishlistItemBySKU;
};

export const addWishlistItemBySKU = (
  sku: string,
  context: Record<string, unknown> = {},
  options?: { runInBackground?: boolean }
) => {
  if (options?.runInBackground) {
    return addWishlistItemBySKUInner(sku, context);
  }
  return withGlobalSpinner(() => addWishlistItemBySKUInner(sku, context))();
};
